import TabControlAPI from './tab-control-api';

export default TabControlAPI;
